<template>
  <div class="mt-5 mx-0 editBG">
    <!-- <h1>User Management </h1> -->
    <!-- <v-snackbar v-model="snackbar" auto-height right top :timeout="timeout" vertical> User saved. </v-snackbar> -->

        <v-card class="editBG elevation-0">
          <!-- <v-card-title> <span class="pl-4 pt-3 pb-0 mb-0 headline">Edit Article</span> </v-card-title> -->

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn icon @click="$router.go(-1)"><v-icon>arrow_back</v-icon></v-btn>
            <!-- <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn> -->
            <v-btn color="black" flat @click="createArticle">Save</v-btn>
          </v-card-actions>

          <v-card-text mb-0>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field v-model="article.title" label="Title"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="article.subtitle" label="Subtitle"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field v-model="article.version" label="Version"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field v-model="article.support" label="Support"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field v-model="article.updates" label="Updates"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field v-model="article.group" label="Group"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field v-model="article.at_work" label="At Work"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field v-model="article.publish_date" label="Publish Date"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="article.show_in_route" label="Routes Array"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <text-editor @input="article.body=$event" :value="article.body"></text-editor>
                  <v-divider class="my-4"></v-divider>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
        <!-- <v-btn class="justify-center layout px-0"> <v-icon small class="mr-2" @click="editItem(props.item)" > edit </v-icon> </v-btn> -->

  </div>
</template>

<script>
  import TextEditor from '@/components/artworks/TextEditor'
  import axios from 'axios'
  export default {
    data() {
      return {
        editedIndex: -1,
        article: {
          title:'',
          version: '',
          subtitle: '',
          updates: '',
          help: '',
          at_work: '',
          support: '',
          show_in_route: '',
          group: ''
        },
        defaultItem: {
          title:'',
          version: '',
          subtitle: '',
          updates: '',
          help: '',
          at_work: '',
          support: '',
          show_in_route: '',
          group: '',
          body: ''
        }
      }
    },
    // beforeMount () {
    //   // console.log(this.editedItem)
    //   if (this.editedItem) {
    //     this.article = Object.assign({},this.editedItem)
    //   } 
    //   this.getArticle()
    // },
    methods: {
      createArticle () {
        // this.snackbar = true
        let url = `${this.$globals.apiserver}/support_articles.json`
        axios.post(url, { article: this.article }).then((response) => {
          // this.result = response.data
          // var o = Object.assign({ name: this.newItem.title})
          this.$store.dispatch('createArticle', response.data)
          // this.snackbar = false
          this.article = this.defaultItem
          this.$router.push({ path: '/articles'})
          // this.$router.push({path:`/users/edit/${this.result.id}`, params: {user: this.result}})
        }).catch((error) => { console.log(error) })
      }
    },
    components: { TextEditor }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/support/AddArticle.vue